<div [formGroup]="form">
    <div *ngIf="controlForm.controlType == 'CheckBoxForm'" fxFlex appearance="outline" class="mat-form-field">
        <mat-checkbox [formControlName]="controlForm.key"
            [id]="controlForm.key">
            <mat-label >{{ browserLang == "en" ? controlForm.label_en : controlForm.label_es }}</mat-label>
        </mat-checkbox>
    </div>
    <mat-form-field *ngIf="controlForm.controlType != 'CheckBoxForm'" fxFlex appearance="outline">
        <mat-label >{{ browserLang == "en" ? controlForm.label_en : controlForm.label_es }}{{ controlForm.required ? " *" : ""}} </mat-label><!--[attr.for]="controlForm.key"-->
        <ng-container [ngSwitch]="controlForm.controlType">  
            <input *ngSwitchCase="'TextBoxNumberForm'" matInput type="number" fxFill [formControlName]="controlForm.key"
                [id]="controlForm.key" [type]="controlForm.type">
            <input *ngSwitchCase="'TextBoxStringForm'" matInput [formControlName]="controlForm.key"
                [id]="controlForm.key" [type]="controlForm.type">
            <mat-select *ngSwitchCase="'DropdownStringForm'" matInput [formControlName]="controlForm.key"
                [id]="controlForm.key"> <!--(selectionChange)="changeSelection($event)"-->
                <mat-option *ngFor="let opt of controlForm.options" [value]="opt.key">
                    {{opt.value}}</mat-option>
            </mat-select>
            <input *ngSwitchCase="'CheckBoxForm'" hidden=true matInput style="display: none;"/>            
        </ng-container>
        <div class="errorMessage" *ngIf="!isValid"></div>
        <mat-error *ngIf="!isValid">{{ browserLang == "en" ? "Data required" : "Dato requerido" }}</mat-error>
    </mat-form-field>
</div>